import { useMutation } from '@apollo/client';

import { useParams } from 'react-router-dom';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

import { notificationService } from '@/services/notification/notification.client';
import { UpdateUsageHeader, UpdateUsageHeaderVariables } from
  '@/graphql/contracts/_generated_/updateUsageHeader.mutation';
import { UpdateUsageHeaderInputType } from '@/graphql/contracts/_generated_/contracts';

import UpdateUsageHeaderMutation from '@/graphql/contracts/updateUsageHeader.mutation.gql';
import GetVarBillingUsageHeaderQuery from '@/graphql/contracts/getVarBillingUsageHeader.query.gql';
import GetVarBillingUsageDetailsStatsQuery from '@/graphql/contracts/getVarBillingUsageDetailsStats.query.gql';

export default function useUpdateUsageHeader() {
  const { fileId }: { fileId: string } = useParams();
  const [_updateUsageHeader, { loading }] = useMutation<UpdateUsageHeader, UpdateUsageHeaderVariables>(
    UpdateUsageHeaderMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    },
  );

  const updateUsageHeader = (usageHeaderDTO: UpdateUsageHeaderInputType, successCb?: () => void) => {
    _updateUsageHeader({
      variables: { input: usageHeaderDTO },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetVarBillingUsageHeaderQuery,
          variables: {
            id: fileId
          },
        },
        {
          query: GetVarBillingUsageDetailsStatsQuery,
          variables: {
            filter: {
              headerPrimaryKey: { eq: usageHeaderDTO.usageHeaderId }
            },
          },
        },
      ],
      onCompleted: () => {
        successCb?.();
        notificationService.open({
          title: 'Update Usage Header',
          text: 'Usage header successfully updated',
          type: 'success'
        });
      }
    });

  };

  return {
    updateUsageHeader,
    isLoadingUpdateUsageHeader: loading
  } as const;
}
